import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from 'react-query'
import SnackbarProvider from 'react-simple-snackbar'

import App from './App'

import './index.css'

const queryClient = new QueryClient()
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <QueryClientProvider client={queryClient}>
    <SnackbarProvider>
      <App />
    </SnackbarProvider>
  </QueryClientProvider>,
)
